/* eslint-disable max-len */
//
// WARNING: this file was auto-generated by @phensley/cldr-compiler. DO NOT EDIT.
//

/** @public */
export type MetaZoneType =   'Acre' |  'Afghanistan' |  'Africa_Central'
 |  'Africa_Eastern' |  'Africa_Southern' |  'Africa_Western'
 |  'Alaska' |  'Almaty' |  'Amazon' |  'America_Central'
 |  'America_Eastern' |  'America_Mountain' |  'America_Pacific'
 |  'Anadyr' |  'Apia' |  'Aqtau' |  'Aqtobe' |  'Arabian'
 |  'Argentina' |  'Argentina_Western' |  'Armenia' |  'Atlantic'
 |  'Australia_Central' |  'Australia_CentralWestern'
 |  'Australia_Eastern' |  'Australia_Western' |  'Azerbaijan'
 |  'Azores' |  'Bangladesh' |  'Bhutan' |  'Bolivia' |  'Brasilia'
 |  'Brunei' |  'Cape_Verde' |  'Casey' |  'Chamorro' |  'Chatham'
 |  'Chile' |  'China' |  'Christmas' |  'Cocos' |  'Colombia'
 |  'Cook' |  'Cuba' |  'Davis' |  'DumontDUrville' |  'East_Timor'
 |  'Easter' |  'Ecuador' |  'Europe_Central' |  'Europe_Eastern'
 |  'Europe_Further_Eastern' |  'Europe_Western' |  'Falkland'
 |  'Fiji' |  'French_Guiana' |  'French_Southern' |  'GMT'
 |  'Galapagos' |  'Gambier' |  'Georgia' |  'Gilbert_Islands'
 |  'Greenland' |  'Greenland_Eastern' |  'Greenland_Western'
 |  'Guam' |  'Gulf' |  'Guyana' |  'Hawaii_Aleutian' |  'Hong_Kong'
 |  'Hovd' |  'India' |  'Indian_Ocean' |  'Indochina'
 |  'Indonesia_Central' |  'Indonesia_Eastern'
 |  'Indonesia_Western' |  'Iran' |  'Irkutsk' |  'Israel'
 |  'Japan' |  'Kamchatka' |  'Kazakhstan' |  'Kazakhstan_Eastern'
 |  'Kazakhstan_Western' |  'Korea' |  'Kosrae' |  'Krasnoyarsk'
 |  'Kyrgystan' |  'Lanka' |  'Line_Islands' |  'Lord_Howe'
 |  'Macau' |  'Magadan' |  'Malaysia' |  'Maldives' |  'Marquesas'
 |  'Marshall_Islands' |  'Mauritius' |  'Mawson'
 |  'Mexico_Pacific' |  'Mongolia' |  'Moscow' |  'Myanmar'
 |  'Nauru' |  'Nepal' |  'New_Caledonia' |  'New_Zealand'
 |  'Newfoundland' |  'Niue' |  'Norfolk' |  'Noronha'
 |  'North_Mariana' |  'Novosibirsk' |  'Omsk' |  'Pakistan'
 |  'Palau' |  'Papua_New_Guinea' |  'Paraguay' |  'Peru'
 |  'Philippines' |  'Phoenix_Islands' |  'Pierre_Miquelon'
 |  'Pitcairn' |  'Ponape' |  'Pyongyang' |  'Qyzylorda'
 |  'Reunion' |  'Rothera' |  'Sakhalin' |  'Samara' |  'Samoa'
 |  'Seychelles' |  'Singapore' |  'Solomon' |  'South_Georgia'
 |  'Suriname' |  'Syowa' |  'Tahiti' |  'Taipei' |  'Tajikistan'
 |  'Tokelau' |  'Tonga' |  'Truk' |  'Turkmenistan' |  'Tuvalu'
 |  'Uruguay' |  'Uzbekistan' |  'Vanuatu' |  'Venezuela'
 |  'Vladivostok' |  'Volgograd' |  'Vostok' |  'Wake' |  'Wallis'
 |  'Yakutsk' |  'Yekaterinburg' |  'Yukon';
